import { isCouponAvailable } from '@/api';
import { ClientAuth, Device, Logger } from '@/classes';
import { DAY_MS } from '@/constants';
import { PopupContext } from '@/contexts/PopupContext';
import { useRouter } from '@/hooks/useRouter';
import { HomeContainerList } from '@/widgets/home-container-list';
import { Menu } from '@/widgets/menu';
import { useCallback, useContext, useEffect } from 'react';

export const HomePage = () => {
  const router = useRouter();
  const popupContext = useContext(PopupContext);

  const showPromotionPopup = useCallback(async () => {
    // ! Tizen Promotion 기간동안만 진행 (추후 전체 제거 PopupContext 도 제거 필요)
    const promotionCode = 'SAMSUNG2025';
    localStorage.setItem('lastPromotionExposedAt', String(Date.now()));

    try {
      const isAvailablePromotionCode = await isCouponAvailable(promotionCode);
      if (isAvailablePromotionCode) {
        popupContext.showSubscribePopup('home', 'home', undefined, promotionCode);
        return;
      } else {
        throw new Error('Promotion code is not available');
      }
    } catch (e) {
      console.error(e);
    }
  }, [popupContext]);

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  useEffect(() => {
    Logger.exposedHome();
  }, []);

  useEffect(() => {
    if (Device.isTizen && ClientAuth.user && !ClientAuth.user.isSubscriber) {
      const lastExposedAt = Number(localStorage.getItem('lastPromotionExposedAt'));
      if (Number.isNaN(lastExposedAt) || lastExposedAt < Date.now() - DAY_MS) {
        showPromotionPopup();
      }
    }
  }, [popupContext, showPromotionPopup]);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <Menu />
      <div className="flex flex-1 overflow-hidden">
        <HomeContainerList />
      </div>
    </div>
  );
};
